import { IconButton, TablePagination, createStyles, makeStyles } from "@material-ui/core";
import { TablePaginationActionsProps } from "@material-ui/core/TablePagination/TablePaginationActions";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import useText from "constants/text";
import React from "react";
import { LabelDisplayedRows } from "./LabelDisplayedRows";
import { useTableStyles } from "./styles";

export interface TableFooterProps {
  page?: number;
  rowsPerPage?: number;
  count?: number;
  handleChangePage?(event: unknown, newPage: number): void;
  handleChangeRowsPerPage?(event: React.ChangeEvent<HTMLInputElement>): void;
  rowsPerPageOptions: number[];
  footerWidth?: string;
}

export const TableFooter = ({
  rowsPerPage,
  page = 1,
  count = 0,
  handleChangePage = () => { },
  handleChangeRowsPerPage = () => { },
  rowsPerPageOptions,
  footerWidth = "auto",
}: TableFooterProps) => {
  const styles = useTableStyles({});
  const { text } = useText();

  React.useEffect(() => {
    [].slice.call(document.querySelectorAll(".MuiTablePagination-caption")).map((element) => {
      if (element.id) {
        element.innerText = `${count} ${text.all.elements}`;
        return element;
      }
      element.innerText = "";
      return element;
    });
  }, [count, document.querySelectorAll(".MuiTablePagination-caption")]);

  return (
    <TablePagination
      style={{ minWidth: footerWidth }}
      className={styles.countTotal}
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      ActionsComponent={TablePaginationActions}
      labelRowsPerPage=""
      onPageChange={handleChangePage}
    />
  );
};

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onChangePage } = props;
  const { text } = useText();
  const styles = useTableStyles({});
  function handleBackButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    onChangePage(event, page - 1);
  }
  function handleNextButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    onChangePage(event, page + 1);
  }

  React.useEffect(() => {
    [].slice.call(document.querySelectorAll(".MuiTablePagination-caption")).map((element) => {
      if (element.id) {
        element.innerText = `${count} ${text.all.elements}`;
        return element;
      }
      element.innerText = "";
      return element;
    });
  }, [count, document.querySelectorAll(".MuiTablePagination-caption")]);

  return (
    <>
      <span className={styles.spanStyled}>{text.all.per_page}</span>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="Previous Page">
        <KeyboardArrowLeft className={styles.KeyboardArrowLeft} />
      </IconButton>
      <LabelDisplayedRows count={count} page={page} total={rowsPerPage} />
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        <KeyboardArrowRight className={styles.KeyboardArrowRight} />
      </IconButton>
    </>
  );
}

export default TablePaginationActions;
